import axios from "axios";

const displayWeather = async (weatherDiv) => {
  if (!weatherDiv) return;
  try {
    axios.get("/weather").then((response) => {
      console.log(response);
      const { icon, temp } = response.data;
      displayHTML(temp, icon);
    });
  } catch (e) {
    console.log(e);
  }
};

const displayHTML = (temp, icon) => {
  $("#weather_temperature").html(`${temp}&#176;C`);
  $("#weather_icon").attr("src", `../images/icons/${icon}.svg`);
};
export default displayWeather;



// WEBPACK FOOTER //
// ./public/javascripts/modules/weather.js